import React from "react";
import { Card } from "antd";
import { defaultColors } from "@/themes/antd-theme";
import { useTheme } from "@/App";
import { useTranslation } from "react-i18next";
// import Typography from "antd";


// const { Title, Text } = Typography;
const StatCard = ({
  icon,
  label,
  value,
  bgColor,
  iconColor,
}) => {
  const { isDark } = useTheme();
  const { t } = useTranslation();
  const finalBgColor =
    bgColor || (isDark
      ? defaultColors.palette.teal[900]
      : defaultColors.palette.teal[50]);

  const finalIconColor = iconColor || defaultColors.primary;

  const cardBgColor = isDark
    ? defaultColors.palette.gray[800]
    : "#ffffff";
      
  return (
    <Card
      bordered={false}
      className="transition-all duration-300 cursor-pointer hover:-translate-y-1 hover:shadow-lg"
      bodyStyle={{ padding: "18px" }}
      style={{
        backgroundColor: cardBgColor,
        borderRadius: 14,
        borderBottom: `4px solid ${finalIconColor}`, // Match icon color for consistency
        boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
        height: "100%",
      }}
    >
      <div className="flex items-center gap-4">
        <div
          className="flex items-center justify-center rounded-2xl"
          style={{ backgroundColor: finalBgColor, width: 52, height: 52 }}
        >
          {React.cloneElement(icon, {
            size: 24,
            color: finalIconColor,
          })}
        </div>

        <div className="flex-1">
          <p
            className="text-sm m-0"
            style={{ color: isDark ? "#9ca3af" : "#6b7280" }}
          >
            {t(label)}
          </p>
          <h3
            className="text-2xl font-bold mt-1 mb-0"
            style={{ color: isDark ? "#f3f4f6" : "#111827" }}
          >
            {value}
          </h3>
        </div>
      </div>
    </Card>
  );
};

export default StatCard;
